// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal[data-v-02df7a92] {\n  margin: 30px;\n  max-width: 500px;\n  width: auto;\n  background: transparent;\n  box-shadow: none;\n}\n.modal-body[data-v-02df7a92] {\n  display: flex;\n  padding: 30px;\n}\n.hidden[data-v-02df7a92] {\n  opacity: 0;\n}\n", ""]);
// Exports
module.exports = exports;
